export default __webpack_public_path__ + "static/media/user_guide_for_PAYE.6258c8f0.pdf";